import { Observable, catchError, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EngineReport } from '@navstation-portal/reporting/data-model/engine-report';
import { AuthStore } from '@navstation-portal/shared/data-access/auth';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';

@Injectable({ providedIn: 'root' })
export class EngineReportService {
  private http = inject(HttpClient);
  private authStore = inject(AuthStore);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('EngineReport');

  getMainEngineReport(vesselId: string, reportId: string): Observable<EngineReport> {
    if (!this.authStore.isLoggedIn()) return throwError(() => new Error('Not logged in.'));
    if (!vesselId) return throwError(() => new Error('vesselId is required'));
    if (!reportId) return throwError(() => new Error('reportId is required'));

    return this.http
      .get<EngineReport>(`${this.baseUrl}/${vesselId}/meReports`, { params: { reportId } })
      .pipe(catchError(this.apiError.toApiError('getting the main engine report')));
  }

  submitMainEngineReport(vesselId: string, report: EngineReport, closeReport = false): Observable<EngineReport> {
    if (!this.authStore.isLoggedIn()) return throwError(() => new Error('Not logged in.'));
    if (!vesselId) return throwError(() => new Error('vesselId is required'));

    const params = closeReport ? { closeReport: true } : undefined;

    return this.http
      .post<EngineReport>(`${this.baseUrl}/${vesselId}/meReports`, report, { params })
      .pipe(catchError(this.apiError.toApiError('submitting the main engine report')));
  }
}
